import React, { useState } from 'react';
import { Box, Container, Typography, Paper, Link as MuiLink, Modal, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import ParallaxHeader from '../components/ParallaxHeader';

const galleryImages = [
  '/images/content/products/Brands-pulp-slider5-large-1920w.jpg',
  '/images/content/products/Matrix-Logo-1-1920w.png',
  '/images/content/products/mydentity-products-7-1920w.jpg',
  '/images/content/products/natulique_1_-1920w.png',
];

const About = () => {
  const [open, setOpen] = useState(false);
  const [selectedImg, setSelectedImg] = useState<string | null>(null);

  const handleOpen = (img: string) => {
    setSelectedImg(img);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedImg(null);
  };

  return (
    <>
      <ParallaxHeader title="About Us" description="Welcome To Stylist Inside!" imageUrl="/images/content/lady-doing-hair.jpg" height={300} />
      <Box sx={{ py: 8, backgroundColor: 'background.paper' }}>
        <Container maxWidth="lg">
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 4 }}>
            {/* Main content */}
            <Box sx={{ flex: 2, minWidth: 0 }}>
              <Paper elevation={3} sx={{ p: 5, borderRadius: 3 }}>
                <Typography variant="body1" sx={{ mt: 3, fontSize: '1.2rem', whiteSpace: 'pre-line' }}>
                  {`This Salon is our dream come true. I have spent my life making people beautiful and the past 10 years of my life doing this as a cosmetologist. I want to create an atmosphere where my guests are always welcome. A home away from home. I call the guests because the people I serve are more than a customer or a client. They are more like family and friends.

At Stylist Inside you can expect a professional and quality service at every visit. We make it our business to ensure you that you will leave with a smile on your face and wanting to come back for more.

So stop by and give us a try or stop by just to say hello.`}
                </Typography>
                {/* Gradient divider section with Meet The Team button */}
                <Box sx={{
                  width: 'calc(100% + 40px)',
                  position: 'relative',
                  left: '-20px',
                  my: 5,
                  py: 3,
                  px: { xs: 2, md: 4 },
                  borderRadius: 3,
                  background: 'linear-gradient(90deg, #a886e5 0%, #7b2ff2 100%)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  boxShadow: 3,
                }}>
                  <Typography variant="h5" align="center" sx={{ color: 'white', mb: 2, fontWeight: 'bold' }}>
                    Want to know more about our stylists?
                  </Typography>
                  <MuiLink component={Link} to="/team" underline="none">
                    <Typography
                      variant="button"
                      sx={{
                        px: 3,
                        py: 1,
                        bgcolor: 'transparent',
                        borderRadius: '12px',
                        border: '3px solid',
                        borderColor: 'white',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '1rem',
                        cursor: 'pointer',
                        boxShadow: 1,
                        transition: 'background 0.2s, color 0.2s',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.15)',
                          color: 'white',
                        },
                        minWidth: 120,
                        textAlign: 'center',
                        letterSpacing: 1,
                      }}
                    >
                      Meet The Team!
                    </Typography>
                  </MuiLink>
                </Box>
                {/* End gradient divider section */}
                <Typography variant="subtitle1" align="center" sx={{ mb: 1 }}>
                  We proudly use Matrix Hair Care Products
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                  <img 
                    src="/images/content/products/New-Matrix-Biolage-Main-Logo-Dark-Grey-1020w.jpg"
                    alt="Matrix Product Logo"
                    style={{ maxWidth: '320px', width: '100%', height: 'auto', borderRadius: 8 }}
                  />
                </Box>
              </Paper>
            </Box>
            {/* Gallery on the right */}
            <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', mt: { xs: 4, md: 0 } }}>
              <Box sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr 1fr', md: '1fr 1fr' },
                gap: 2,
                width: '100%',
                maxWidth: 340,
              }}>
                {galleryImages.map((img, idx) => (
                  <Box key={img} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <img
                      src={img}
                      alt={`Product ${idx + 1}`}
                      style={{
                        width: '100%',
                        maxWidth: 160,
                        height: 110,
                        objectFit: 'cover',
                        borderRadius: 8,
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                      }}
                      onClick={() => handleOpen(img)}
                    />
                  </Box>
                ))}
              </Box>
              <Modal open={open} onClose={handleClose}>
                <Box sx={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  bgcolor: 'rgba(0,0,0,0.85)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 1300,
                }}>
                  <IconButton onClick={handleClose} sx={{ position: 'absolute', top: 24, right: 24, color: 'white', zIndex: 1400 }}>
                    <CloseIcon fontSize="large" />
                  </IconButton>
                  {selectedImg && (
                    <img
                      src={selectedImg}
                      alt="Expanded Product"
                      style={{
                        maxWidth: '90vw',
                        maxHeight: '80vh',
                        borderRadius: 12,
                        boxShadow: '0 4px 32px rgba(0,0,0,0.25)',
                      }}
                    />
                  )}
                </Box>
              </Modal>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default About;
